import { commentsData } from '@/mocks/chiguaHomeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            瓜友热议
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            吃瓜群众对今日吃瓜最新动态的精彩点评
          </p>
        </div>

        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-5">
          {commentsData.map((comment, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-5">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-0.5">
                    <span className="text-sm font-medium text-foreground-900 whitespace-nowrap">{comment.name}</span>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{comment.time}</span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    {comment.content}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-4 text-xs text-foreground-500 pl-[52px]">
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-thumb-up-line"></i>
                  {comment.likes.toLocaleString()}
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-1-line"></i>
                  回复
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-share-forward-line"></i>
                  分享
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}